import React from 'react';
import PropTypes from 'prop-types';

import DataAttributeHelper from '../../../../../helpers/DataAttributeHelper';
import HorizontalFlow from '../../../../_layouts/HorizontalFlow';
import DropdownButtonComponent from './styles';

const DropdownButton = (props) => {
  const {
    buttonType,
    children,
    classNames,
    data,
    disabled,
    href,
    modalRemote,
    onClick,
    selected,
  } = props;

  const modalRemoteProps = (path) => ({
    'data-action': 'modal-remote#show',
    'data-controller': 'modal-remote',
    'data-modal-remote-url': path,
  });

  return (
    <DropdownButtonComponent
      classNames={classNames}
      selected={selected}
      onClick={onClick}
      disabled={disabled}
      danger={buttonType === 'danger'}
      {...(modalRemote ? modalRemoteProps(href) : { href })}
      {...DataAttributeHelper.fromObject(data)}
    >
      <HorizontalFlow>{children}</HorizontalFlow>
    </DropdownButtonComponent>
  );
};

DropdownButton.defaultProps = {
  avatarUrl: null,
  badgeText: null,
  buttonType: null,
  data: {},
  disabled: false,
  href: null,
  leftIcon: null,
  modalRemote: false,
  onClick: null,
  rightIcon: null,
  selected: null,
  classNames: '',
};

DropdownButton.propTypes = {
  classNames: PropTypes.string,
  avatarUrl: PropTypes.string,
  badgeText: PropTypes.string,
  buttonType: PropTypes.string,
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]).isRequired,
  data: PropTypes.objectOf(PropTypes.string),
  disabled: PropTypes.bool,
  href: PropTypes.string,
  leftIcon: PropTypes.string,
  modalRemote: PropTypes.bool,
  onClick: PropTypes.func,
  rightIcon: PropTypes.string,
  selected: PropTypes.bool,
};

export default DropdownButton;
